import { doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "./firebase";
import { getOriginalSentence } from "./getOriginalSentence";
export const addOriginalSentence = async (teacherId, sentenceArray) => {

  try {
    const teacherRef = doc(db, 'original_sentence', teacherId);
    await getOriginalSentence(teacherId).then(async (tmpObj) => {
      if (!tmpObj) {
        tmpObj = Object();
      }
      const objLen = Object.keys(tmpObj).length + 1;
      tmpObj[objLen] = {
        1: {
          word_top: sentenceArray['whoTop'],
          word_bottom: sentenceArray['whoBottom'],
        },
        2: {
          word_top: sentenceArray['doTop'],
          word_bottom: sentenceArray['doBottom'],
        },
        3: {
          word_top: sentenceArray['whatTop'],
          word_bottom: sentenceArray['whatBottom'],
        },
        4: {
          word_top: sentenceArray['howTop'],
          word_bottom: sentenceArray['howBottom'],
        },
        5: {
          word_top: sentenceArray['whereTop'],
          word_bottom: sentenceArray['whereBottom'],
        },
        6: {
          word_top: sentenceArray['whenTop'],
          word_bottom: sentenceArray['whenBottom'],
        },
        7: {
          word_top: sentenceArray['whyTop'],
          word_bottom: sentenceArray['whyBottom'],
        },
        completed_english_sentence: sentenceArray['sentence'],
        sentence_len: 0,
      }

      for (let i = 1; i <= 7; i++) {
        if (tmpObj[objLen][i]['word_top'] || tmpObj[objLen][i]['word_bottom']) tmpObj[objLen]['sentence_len'] += 1;
      }




      await setDoc(teacherRef, tmpObj);
    })
    return true;


  } catch (err) {
    console.log("Error", err);
    return "error";
  }
}
